import { cn } from "@/ds/utils";
import type { FC, PropsWithChildren, ReactNode } from "react";

export interface MediaObjectProps extends PropsWithChildren {
	media: ReactNode;
	title: ReactNode;
	description?: ReactNode;
	size?: "sm" | "lg";
	onClick?: () => void;
	className?: string;
}

export const MediaObject: FC<MediaObjectProps> = props => {
	const {
		media,
		title,
		description,
		size = "sm",
		onClick,
		className,
		children
	} = props;

	if (size === "lg") {
		return (
			<div className={cn("flex h-full", onClick && "cursor-pointer", className)} onClick={onClick}>
				<div className="shrink-0 border-r">
					{media}
				</div>
				<div className="flex min-w-0 grow flex-col">
					<div className="grow border-b px-2 py-1">
						<div className="type-item">{title}</div>

						{
							description &&
							<div className="type-meta">{description}</div>
						}
					</div>
					{children}
				</div>
			</div>
		);
	}

	return (
		<div className={cn("flex items-center gap-2 min-w-0", onClick && "cursor-pointer", className)} onClick={onClick}>
			<div className="shrink-0">
				{media}
			</div>
			<div className="min-w-0 flex-1">
				<div className="type-item truncate">{title}</div>

				{
					description &&
					<div className="type-meta truncate">{description}</div>
				}
			</div>
			{children}
		</div>
	);
};

export interface DataPointProps extends PropsWithChildren {
	label?: ReactNode;
	className?: string;
}

export const DataPoint: FC<DataPointProps> = props => {
	const {
		label,
		className,
		children
	} = props;

	return (
		<div className={cn("flex flex-col min-w-0", className)}>
			{children}

			{
				label &&
				<div className="type-meta">{label}</div>
			}
		</div>
	);
};

export interface DataPointGroupProps extends PropsWithChildren {
	className?: string;
}

export const DataPointGroup: FC<DataPointGroupProps> = props => {
	const {
		className,
		children
	} = props;

	return (
		<div className={cn("flex flex-wrap items-center justify-between gap-2 p-2 text-sm", className)}>
			{children}
		</div>
	);
};
